import '../boolean_filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.PageOwnerFilterView extends Monitoring.Views.SocialContents.Filters.BooleanFilterView
  name: 'page_owner'
  visibleInMyHistorySession: false

  initialize: ({searchQuery}) ->
    super(
      searchQuery: searchQuery
      title: I18n.t('monitoring.dashboard.filters.filter_names.page_owner.name')
      trueField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'include_page_owner_generated'
        title: I18n.t('monitoring.dashboard.filters.filter_names.page_owner.include')
      falseField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'exclude_page_owner_generated'
        title: I18n.t('monitoring.dashboard.filters.filter_names.page_owner.exclude')
    )
